import { Typography, TypographyProps } from '@mui/material';
import { SxProps, Theme } from '@mui/material';

interface ContentTitleProps extends Omit<TypographyProps, 'sx'> {
  sx?: SxProps<Theme>;
}

export function ContentTitle({ children, sx, ...props }: ContentTitleProps) {
  return (
    <Typography
      sx={{
        color: '#0E0F11',
        fontSize: 24,
        fontFamily: 'Inter',
        fontWeight: 600,
        lineHeight: '32px',
        letterSpacing: '-0.408px',
        ...sx,
      }}
      {...props}
    >
      {children}
    </Typography>
  );
}

interface ContentBodyProps extends Omit<TypographyProps, 'sx'> {
  sx?: SxProps<Theme>;
}

export function ContentBody({ children, sx, ...props }: ContentBodyProps) {
  return (
    <Typography
      component="div"
      sx={{
        fontSize: '16px',
        color: '#636B75',
        fontFamily: 'Inter',
        fontWeight: 400,
        lineHeight: '28px',
        letterSpacing: '-0.096px',
        whiteSpace: 'pre-line',
        ...sx,
      }}
      {...props}
    >
      {children}
    </Typography>
  );
}
